import { render, staticRenderFns } from "./TransitionField.vue?vue&type=template&id=383ff1aa&"
import script from "./TransitionField.vue?vue&type=script&lang=js&"
export * from "./TransitionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports